import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Grid, Button, Box, InputLabel, FormControl, Select, MenuItem } from '@mui/material';

const validationSchema = Yup.object({});

interface TahsilatSabitleriProps {
    sabit: any;
    onUpdate: (updatedValues: any) => Promise<void>;
}

const TahsilatSabitleri: React.FC<TahsilatSabitleriProps> = ({ sabit, onUpdate }) => {

    const handleSubmit = async (values: any) => {
        const updatedValues = {
            ...sabit,
            tahsilatAp: values.tahsilatAp,
        };
        await onUpdate(updatedValues);
    };

    return (
        <Formik
            enableReinitialize
            initialValues={{
                tahsilatAp: sabit?.tahsilatAp || '',
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ values, handleChange, handleBlur, dirty }) => (
                <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel id="tahsilatAp-label">Tahsilat Aktif/Pasif</InputLabel>
                                <Select
                                    labelId="tahsilatAp-label"
                                    id="tahsilatAp"
                                    name="tahsilatAp"
                                    value={values.tahsilatAp ?? ''}
                                    label="Tahsilat Aktif/Pasif"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    sx={{ minHeight: 56 }}
                                >
                                    <MenuItem value="A">Aktif</MenuItem>
                                    <MenuItem value="P">Pasif</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Box textAlign={{ xs: 'center', md: 'right' }}>
                                <Button type="submit" variant="contained" disabled={!dirty}>
                                    Kaydet
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    );
};

export default TahsilatSabitleri;
